module.exports = __webpack_public_path__ + "media/dummy.f893ace7.mp4";